import React, { useEffect, useState } from 'react';
import styles from './MerchantSample.module.css';
import { NavLink } from 'react-router-dom';
import categories from '../../content/MerchantLabel';
import CollaboratorsCard from '../ui/CollaboratorsCard/CollaboratorsCard';
import getSample from './getSample';

const MerchantSample = ({ index }) => {
    const category = categories[index];
    const [traderCard, setTraderCard] = useState([]);
    const [empty, setEmpty] = useState(true);

    useEffect(() => {
        async function fetchSample() {
            const sample = await getSample(index);
            sample ? setEmpty(false) : setEmpty(true);
            setTraderCard(sample);
        }
        fetchSample();
    }, [index]);

    return (
        <div className={styles.suggestion}>
            <div className={styles.header}>
                <div className={styles.hero}>
                    <h1 className={styles.title}>{category.name}: {category.title}</h1>
                    <p className={styles.subtitle}>{category.description}</p>
                </div>
                {category.to && (
                    <NavLink className={styles.redirect} to={category.to}>
                        <img className={styles.arrow} src='/BreadCrumb/forwardIcon.png' alt='' />
                        <p className={styles.more}>Tout afficher</p>
                    </NavLink>
                )}
            </div>

            <div className={`${styles.layout} ${empty ? styles.default : ''}`}>
                {empty ? (
                    <h1 className={styles.defaultTitle}>Pas de collaborateurs pour le moment</h1>
                ) : (
                    traderCard.map((t) => (
                        <CollaboratorsCard key={t.id} id={t.id} company={t.company} address={t.address} />
                    ))
                )}
            </div>
        </div>
    );
};

export default MerchantSample;
